import { 
    DEPARTURE_SCHEDULE_REQUEST_GET_REQUEST, DEPARTURE_SCHEDULE_REQUEST_GET_SUCCESS, DEPARTURE_SCHEDULE_REQUEST_GET_ERROR, 
    DEPARTURE_SCHEDULE_REQUEST_GET_BY_KEY_REQUEST, DEPARTURE_SCHEDULE_REQUEST_GET_BY_KEY_SUCCESS, DEPARTURE_SCHEDULE_REQUEST_GET_BY_KEY_ERROR, 
    DEPARTURE_SCHEDULE_REQUEST_ADD_REQUEST, DEPARTURE_SCHEDULE_REQUEST_ADD_SUCCESS, DEPARTURE_SCHEDULE_REQUEST_ADD_ERROR, 
    DEPARTURE_SCHEDULE_REQUEST_EDIT_REQUEST, DEPARTURE_SCHEDULE_REQUEST_EDIT_SUCCESS, DEPARTURE_SCHEDULE_REQUEST_EDIT_ERROR, 
    DEPARTURE_SCHEDULE_REQUEST_DELETE_REQUEST, DEPARTURE_SCHEDULE_REQUEST_DELETE_SUCCESS, DEPARTURE_SCHEDULE_REQUEST_DELETE_ERROR
} from "../constants/departureScheduleRequestConstants";

const initialState = {
    departureScheduleRequests: [],
    departureScheduleRequest: {},
    loading: false,
    success: null,
    error: null,
    departureScheduleRequestRequestedCount: 0,
};

export const departureScheduleRequestReducer = (state = initialState, action) => {
    switch (action.type)     {
        case DEPARTURE_SCHEDULE_REQUEST_GET_REQUEST:
            return {
                ...state,
                departureScheduleRequestRequestedCount: ++state.departureScheduleRequestRequestedCount,
                loading: true,
            };
        case DEPARTURE_SCHEDULE_REQUEST_GET_SUCCESS:
            return {
                ...state,
                loading: false,
                departureScheduleRequests: action.payload,
                success: true,
            };
        case DEPARTURE_SCHEDULE_REQUEST_GET_ERROR:
            return {
                ...state,
                loading: false,
                success: false,
                error: action.payload,
            };
        case DEPARTURE_SCHEDULE_REQUEST_GET_BY_KEY_REQUEST:
            return {
                ...state,
                loading: true,
            };
        case DEPARTURE_SCHEDULE_REQUEST_GET_BY_KEY_SUCCESS:
            return {
                ...state,
                loading: false,
                departureScheduleRequest: action.payload,
                success: true,
            };
        case DEPARTURE_SCHEDULE_REQUEST_GET_BY_KEY_ERROR:
            return {
                ...state,
                loading: false,
                success: false,
                error: action.payload,
            };
        case DEPARTURE_SCHEDULE_REQUEST_ADD_REQUEST:
            return {
                ...state,
                loading: true,
            };
        case DEPARTURE_SCHEDULE_REQUEST_ADD_SUCCESS:
            return {
                ...state,
                loading: false,
                success: true,
            };
        case DEPARTURE_SCHEDULE_REQUEST_ADD_ERROR:
            return {
                ...state,
                loading: false,
                success: false,
                error: action.payload,
            };
        case DEPARTURE_SCHEDULE_REQUEST_EDIT_REQUEST:
            return {
                ...state,
                loading: true,
            };
        case DEPARTURE_SCHEDULE_REQUEST_EDIT_SUCCESS:
            return {
                ...state,
                loading: false,
                success: true,
            };
        case DEPARTURE_SCHEDULE_REQUEST_EDIT_ERROR:
            return {
                ...state,
                loading: false,
                success: false,
                error: action.payload,
            };
        case DEPARTURE_SCHEDULE_REQUEST_DELETE_REQUEST:
            return {
                ...state,
                loading: true,
            };
        case DEPARTURE_SCHEDULE_REQUEST_DELETE_SUCCESS:
            return {
                ...state,
                loading: false,
                success: true,
            };
        case DEPARTURE_SCHEDULE_REQUEST_DELETE_ERROR:
            return {
                ...state,
                loading: false,
                success: false,
                error: action.payload,
            };
        default:
            return state;
    }
}
